import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'app-starting-point',
  templateUrl: './starting-point.component.html',
  styleUrls: ['./starting-point.component.scss'],
})
export class StartingPointComponent extends BaseComponent implements OnInit {
  constructor(private title: Title) {
    super();
  }

  ngOnInit(): void {
    this.title.setTitle('سبد گردان آبان | نقطه شروع');
    super.ngOnInit();
  }
}
